import { useEffect } from 'react';

import { TableContextProvider } from 'lib/context/TableContext/TableContextProvider';
import { FormBuilderContextProvider } from 'lib/context/FormBuilder/FormBuilderContextProvider';

import {
  isSubstepCompleted,
  resolveContinueAction
} from 'components/shared/OnboardingWizard/lib/resolveContinueAction';

import FormBuilderProcess from './components/FormBuilderProcess';

const OnboardingClinicalForms = ({
  setHeaderButtonProps,
  addFooterActions,
  mutateOrchestratorData,
  onNext,
  orchestratorData,
  orchestratorLoading
}) => {
  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: resolveContinueAction({
          isDirty: false,
          isCompleted: isSubstepCompleted(orchestratorData),
          hasExistingData: true,
          onConfirm: () => mutateOrchestratorData({}),
          onNext
        }),
        isDisabled: orchestratorLoading
      }
    ]);
  }, [
    setHeaderButtonProps,
    addFooterActions,
    orchestratorLoading,
    orchestratorData?.handlerStatus
  ]);

  return (
    <FormBuilderContextProvider>
      <TableContextProvider cols={[]} name="forms">
        <FormBuilderProcess setHeaderButtonProps={setHeaderButtonProps} />
      </TableContextProvider>
    </FormBuilderContextProvider>
  );
};

export default OnboardingClinicalForms;
